import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=c599c41a&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=js"
export * from "./AfterSales.vue?vue&type=script&lang=js"
import style0 from "./AfterSales.vue?vue&type=style&index=0&id=c599c41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c599c41a",
  null
  
)

export default component.exports